const breakpoints = {
    XLARGE: 1199,
    LARGE: 991,
    MEDIUM: 767,
    SMALL: 575
}

export default breakpoints;